export default "__VITE_PUBLIC_ASSET__74832caf__"